import { render, staticRenderFns } from "./UserCardnovelties.vue?vue&type=template&id=53441070"
import script from "./UserCardnovelties.vue?vue&type=script&lang=js"
export * from "./UserCardnovelties.vue?vue&type=script&lang=js"
import style0 from "./UserCardnovelties.vue?vue&type=style&index=0&id=53441070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports